import React from 'react';
import { Flex, Spin, Typography } from 'antd';
import { useAnimalLifecycleLabels } from './useAnimalLifecycleLabels';
import SpeciesLifecycleTierTag from './SpeciesLifecycleTierTag';

const { Text } = Typography;

/**
 * Lifecycle tier chips for an animal (shared naming from species-lifecycle-config).
 */
export default function SpeciesLifecycleTierTags({
  animal,
  speciesSlug,
  gender,
  ageMonths,
  breedingStatus,
  isPregnant,
  emptyText = null,
  loadingText = null,
  tagSize = 'small',
  gap = 4,
  wrap = 'wrap',
  ...flexProps
}) {
  const { labels, isReady, isLoading } = useAnimalLifecycleLabels(animal, {
    ...(speciesSlug != null && speciesSlug !== '' ? { speciesSlug } : {}),
    ...(gender != null ? { gender } : {}),
    ...(ageMonths != null ? { ageMonths } : {}),
    ...(breedingStatus != null ? { breedingStatus } : {}),
    ...(isPregnant != null ? { isPregnant } : {}),
  });

  if (isLoading && !isReady) {
    return loadingText ? <Text type="secondary">{loadingText}</Text> : <Spin size="small" />;
  }

  if (!labels.length) {
    return emptyText ? <Text type="secondary">{emptyText}</Text> : null;
  }

  return (
    <Flex gap={gap} wrap={wrap} {...flexProps}>
      {labels.map((item) => (
        <SpeciesLifecycleTierTag key={item.tier} tier={item.tier} name={item.name} size={tagSize} />
      ))}
    </Flex>
  );
}
